export enum LoadingScreenDependencies {
  AUTHENTICATION = 'AUTHENTICATION',
  NAVIGATION = 'NAVIGATION'
}
